import React, { useState } from 'react'
import Axios from 'axios'
import {FaSpinner} from  '../../../node_modules/react-icons/fa/index.js'
import { useNavigate } from 'react-router-dom'
import Joi from 'joi'


export default function Register() {

  const [user, setUser] = useState({
    first_name: '',
    last_name: '',
    age: '',
    email: '',
    password: ''
  })

  const [statusList, setStatusList] = useState([])

  const [isLoading, setIsLoading] = useState(false)

  const navigate = useNavigate()

  function handleChange(e){
    let myUser = {...user}  // this is the same as let first_name = user.first_name, let last_name = user.last_name, etc
    setUser({
      ...myUser,  // this is the same as first_name: user.first_name, last_name: user.last_name, etc
      [e.target.name]: e.target.value,  // this is the same as first_name: e.target.value if the input name is first_name
    })
    console.log(user);
  }

  async function registerNewUserApi(){
      let res = await Axios.post(`http://localhost:8000/users`, user)
      console.log( res);
      // if the email does not exist, show an StatusList message
      if(res.status === 201){
        setIsLoading(false);
        navigate('/login');
      }
      if(res.status === 400){
        setIsLoading(false);
      }else{
        setIsLoading(false);
      }

  }

  function handleSubmit(e){
    e.preventDefault();
    setIsLoading(true);
    let validation = validateUser(user);
    if(validation.error){
      setIsLoading(false);
      setStatusList(validation.error.details);
      setIsLoading(false);
      console.log(validation);
    }else{
      setIsLoading(true);
      registerNewUserApi();
    }
  }

  function validateUser(user){
    const schema = Joi.object({
      first_name: Joi.string().min(3).max(10).required(),
      last_name: Joi.string().min(3).max(10).required(),
      age: Joi.number().min(18).required(),
      email: Joi.string().email({ minDomainSegments: 2, tlds: { allow: ['com', 'net'] } }).required(),
      password: Joi.string().min(6).pattern(/^[a-zA-Z0-9]{3,30}$/).required()
    })
    return schema.validate(user, {abortEarly: false})
  }

  return (
    <div className='d-flex w-50 h-100 m-auto flex-column'>
    <form className='m-2 w-100' onSubmit={handleSubmit}>
      <label htmlFor="first_name">first_name: </label>
      <input onChange={handleChange} className='form-control my-2 my-input' type="text"  id="first_name" name="first_name" />
      {statusList.map((err, index)=>
        err.context.label==='first_name'?  <div key={index} className='alert alert-danger my-2'>{err.message}</div>:null
      )}
      <label htmlFor="last_name">last_name: </label>
      <input onChange={handleChange} className='form-control my-2 my-input' type="text"  id="last_name" name="last_name" />
      {statusList.map((err, index)=>
        err.context.label==='last_name'?  <div key={index} className='alert alert-danger my-2'>{err.message}</div>:null
      )}
      <label htmlFor="age">Age: </label>
      <input onChange={handleChange} className='form-control my-2 my-input' type="number"  id="age" name="age" />
      {statusList.map((err, index)=>
        err.context.label==='age'?  <div key={index} className='alert alert-danger my-2'>{err.message}</div>:null
      )}
      <label htmlFor="email">Email</label>
      <input onChange={handleChange} className='form-control my-2 my-input' type="email" id="email" name="email" />
      {statusList.map((err, index)=>
        err.context.label==='email'?  <div key={index} className='alert alert-danger my-2'>{err.message}</div>:null
      )}
      <label htmlFor="password">Password</label>
      <input onChange={handleChange} className='form-control my-2 my-input' type="password" id="password" name="password" />
      {statusList.map((err, index)=>
        err.context.label==='password'?  <div key={index} className='alert alert-danger my-2'>Invalid password</div>:null
      )}
      <button className='btn btn-info' type="submit">
        {isLoading? <FaSpinner/> : 'Register'}
      </button>
    </form>
    </div>
  )
}
